import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  enh_action: 'promo_click',
  event_name: 'content_module_click',
  event_category: 'ecommerce',
  event_action: 'promotion click',
  event_label: null, // <'banner click | promoName'>
  promo_pos: ['module'], // <'banner click | promoName'>
  promo_creative: null, // <placement/type>
  promo_name: null, // <promoName>
  promo_id: null, // <'module - placement/type - promoName'>
  promo_destination: null // <promoType>
};

function bannerPromoClick(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};

  eventData.event_label = 'banner click|' + eventData?.banner_promo_title;
  eventData.promo_creative = [data.page_type];
  eventData.promo_name = [eventData?.banner_promo_title];
  eventData.promo_id = ['module - ' + data.page_type + ' - ' + eventData?.banner_promo_title];
  eventData.promo_destination = [eventData?.banner_promo_url];
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('bannerClick', bannerPromoClick);